module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-section-1-204fc0fb935eae429f247e5c0e2b677d.webp";